import { atom } from 'recoil';

import { ATOMS } from './constants';

export type ZoomPhoneSession = {
  open: boolean;
  phoneNumber: string;
  relatedId: string;
  autoDial?: boolean;
};

export const zoomPhoneSessionAtom = atom<ZoomPhoneSession | null>({
  key: ATOMS.ZOOM_PHONE_SESSION_ATOM,
  default: null
});
